import CloudChargeLogo from './cloudcharge.svg';

export const logos = { cloudcharge: CloudChargeLogo, defa: CloudChargeLogo, base: CloudChargeLogo };
